import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import Badge from '../../Badge';
import Button from '../../Button';
import Overlay from '../../Overlay';
import Typography from '../../Typography';

import './ControlsMenu.scss';

export interface ControlsMenuProps {
  headerTitle?: string;
  environment?: string;
  backAction?: () => void;
  isVisible: boolean;
  onClose: () => void;
  renderMenu?: (closeAction: () => void) => ReactNode;
}

const ControlsMenu: FC<ControlsMenuProps> = ({
  isVisible = false,
  onClose,
  children,
  headerTitle,
  backAction,
  environment,
  renderMenu,
}) => {
  const controlsMenuClassNames = classNames('sb-controls-menu', {
    'sb-controls-menu_hidden': !isVisible,
  });

  const controlsMenuContainerClassNames = classNames(
    'sb-controls-menu__container',
    {
      'sb-controls-menu__container_hidden': !isVisible,
    },
  );

  const overlayClassNames = classNames('sb-controls-menu__overlay', {
    'sb-controls-menu__overlay_hidden': !isVisible,
  });

  return (
    <div className={controlsMenuClassNames} data-testid="controls-menu">
      <Overlay className={overlayClassNames} type="dark" />

      <div
        className={controlsMenuContainerClassNames}
        data-testid="controls-menu-body"
      >
        <div
          className="sb-controls-menu__header"
          data-testid="controls-menu-header"
        >
          {headerTitle && !backAction && (
            <Typography
              variant="T40"
              className="sb-controls-menu__header-title"
              wrap
            >
              {headerTitle}
            </Typography>
          )}

          {headerTitle && backAction && (
            <Button
              iconPlacement="before"
              iconType="fa-chevron-left"
              labelText="Before"
              styleType="link"
              onClick={backAction}
              className="sb-controls-menu__header-back-action"
              data-testid="controls-menu-header-action"
            >
              {headerTitle}
            </Button>
          )}

          {environment && headerTitle && !backAction && (
            <Badge color="primary" light data-testid="controls-menu-env-name">
              {environment}
            </Badge>
          )}

          <Button
            sizeType="large"
            iconOnly
            iconType="fa-times"
            styleType="demoted"
            labelText="Close"
            onClick={onClose}
            className="sb-controls-menu__header-close-button"
            testMetadata={{ 'data-testid': 'controls-menu-header-close' }}
          />
        </div>

        {renderMenu ? renderMenu(onClose) : children}
      </div>
    </div>
  );
};

export default ControlsMenu;
